import Reveal from './Reveal.jsx'
import { reviews } from '../data/reviews.js'

function StarRating({ stars }) {
  const full = Math.floor(stars)
  const half = stars - full >= 0.5
  const emptyCount = 5 - full - (half ? 1 : 0)
  const label = `${stars} out of 5 stars`
  return (
    <div className="stars" aria-label={label}>
      {'★'.repeat(full)}
      {half ? '★' : ''}
      <span style={{ opacity: 0.35 }}>{'★'.repeat(emptyCount)}</span>
    </div>
  )
}

export default function Reviews() {
  return (
    <section className="reviews" id="reviews">
      <div className="container">
        <div className="section-head">
          <Reveal as="p" className="eyebrow center">Client Love</Reveal>
          <Reveal as="h2" className="section-title center light" delay={60}>Words From Our Court</Reveal>
          <Reveal as="p" className="section-sub center light" delay={120}>
            A few notes from the families and brands we've had the honour of celebrating with.
          </Reveal>
        </div>

        <div className="reviews-grid">
          {reviews.map((review, i) => (
            <Reveal as="article" className="review-card" delay={(i % 3) * 60} key={review.name}>
              <StarRating stars={review.stars} />
              <p className="quote">&ldquo;{review.quote}&rdquo;</p>
              <div className="reviewer">
                <span className="avatar">{review.initials}</span>
                <div>
                  <span className="reviewer-name">{review.name}</span>
                  <span className="reviewer-role">{review.role}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
